export default __webpack_public_path__ + "static/media/Site Management.87744054.svg";